import React from "react";
import Seo from "components/Seo";
import { ReactComponent as RecentFile } from "assets/morning/icon/recentFile.svg";
import { ReactComponent as Close } from "assets/morning/icon/close.svg";
import { ReactComponent as Recent } from "assets/morning/icon/recent.svg";
import { ReactComponent as RightArrow } from "assets/morning/icon/rightArrow.svg";
import { ReactComponent as Search } from "assets/morning/icon/search.svg";
import { ReactComponent as DownArrow } from "assets/morning/icon/downArrow.svg";
import CustomerLayout from "./customerLayout";
import PayMethod from "../../-components/PayMethod";
import ReceiptInfo from "../../-components/ReceiptInfo";
import AddressInfo from "../../-components/AddressInfo";
import OrderList from "../../-components/OrderList";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMorningAuthStore } from "../../../../../store/useMorningAuthStore";
import { usePostAddOrder } from "../../../../../hooks/morning/usePostAddOrder";
import CheckBox from "../../-components/common/Checkbox";
import After1 from "assets/morning/after6-1.png";
import After2 from "assets/morning/after6-2.png";
import Button from "../../-components/common/Button";
import { usePostOrderAccept } from "../../../../../hooks/morning/usePostOrderAccept";
import { useGetLastOrder } from "../../../../../hooks/morning/useGetLastOrder";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SelectBox from "../../-components/common/SelectBox";
import Input from "../../-components/common/Input";
import { useGetOrderSearch } from "../../../../../hooks/morning/useGetOrderSearch";
import { useMasterAuthStore } from "../../../../../store/useMasterAuthStore";
import { usePostMasterLogin } from "../../../../../hooks/morning/usePostMasterLogin";
import { useGetMypageInfo } from "../../../../../hooks/morning/useGetMypageInfo";
import { useGetBusinessDay } from "../../../../../hooks/morning/useGetBusinessDay";
import { usePostOrderFile } from "../../../../../hooks/morning/usePostOrderFile";
import Spinner from "../../../../../components/Spinner";

const sections = [
    { id: "paymethod", title: `발송 및\n 지불 방법` },
    { id: "receiptinfo", title: "접수자 정보" },
    { id: "addressinfo", title: `출발지,\n 도착지 정보` },
    { id: "orderlist", title: `오더접수\n 목록` },
];

const MorningOnlineOrder = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isDevMode = searchParams.get("dev") === "true";

    const isMaster = location.pathname.includes("master");
    const accessToken = useMorningAuthStore(state => state.accessToken ?? "");
    // const { accessToken, checkTokenExpiration } = useMorningAuthStore.getState();

    const c_company = useMorningAuthStore(state => state.c_company ?? "");
    const masterStoreCCode = useMasterAuthStore(state => state.c_code ?? "");
    const morningStoreCCode = useMorningAuthStore(state => state.c_code ?? "");
    const c_code = isMaster ? masterStoreCCode : morningStoreCCode;
    const guestSessionId = useMorningAuthStore(state => state.guestSessionId);
    const isGuest = useMasterAuthStore(state => state.isGuest ?? true);
    const loginAsMember = useMasterAuthStore(state => state.loginAsMember);
    const logoutToGuest = useMasterAuthStore(state => state.logoutToGuest);
    const isLoggedIn = isMaster ? !isGuest : !!accessToken;
    const c_tel = useMorningAuthStore(state => state.c_tel);
    const c_rtel = useMorningAuthStore(state => state.c_rtel);
    const c_setel = useMorningAuthStore(state => state.c_setel);
    const c_req_dept = useMorningAuthStore(state => state.c_req_dept);
    const month_yn = useMorningAuthStore(state => state.c_month_yn ?? "");
    const master_month_yn = useMasterAuthStore(state => state.c_month_yn ?? "");
    const c_month_yn = isMaster ? master_month_yn : month_yn;

    const payMethodRef = useRef<any>(null);
    const receiptRef = useRef<any>(null);
    const addressInfoRef = useRef<any>(null);

    const [showTermsContent, setShowTermsContent] = useState(false);
    const [showCompletePop, setShowCompletePop] = useState<boolean>(false);
    const [arriveIsFocused, setArriveIsFocused] = useState(false);
    const [checkedTerms, setCheckedTerms] = useState(true);
    const [checkedNotice, setCheckedNotice] = useState(true);
    const [deliveryType, setDeliveryType] = useState<"today" | "tomorrow" | null>(null);
    const [selectedIdxList, setSelectedIdxList] = useState<number[]>([]);
    const [recentOrderShow, setRecentOrderShow] = useState<boolean>(false);
    const [loginSearchInput, setLoginSearchInput] = useState("");
    const [showAfter6PMOption, setShowAfter6PMOption] = useState(false);
    // 오더접수 마감 사유 — 휴무일이면 휴무일 이름, 조기종료일이면 조기종료 명칭, 아니면 당일 업무 종료시간(서버 판정, 실패 시 18:00)
    const [closedReason, setClosedReason] = useState<{ holiday: string | null; earlyName: string | null; endTime: string }>({
        holiday: null,
        earlyName: null,
        endTime: "18:00",
    });
    const { data: businessDay, isFetched: isBusinessDayFetched } = useGetBusinessDay();
    const [searchTxt, setSearchTxt] = useState<string>("");
    const [triggerSearchTxt, setTriggerSearchTxt] = useState<string>("");
    const [submitConfirm, setSubmitConfirm] = useState<boolean>(false);
    const [isArriveUseDefault, setIsArriveUseDefault] = useState(false);
    const [isSubmittingOrder, setIsSubmittingOrder] = useState(false);
    const [pickupFiles, setPickupFiles] = useState<File[]>([]);
    const [payMethod, setPayMethod] = useState({
        pickup: 1,
        payment: 1,
        count: "",
        weight: "",
        name: "",
        tel: "",
        manager: "",
        postcode: "",
        address: "",
        addressDetail: "",
        s_pay_company_code: "",
    });
    const [receipt, setReceipt] = useState({
        name: "",
        tel: "",
        department: "",
        departmentName: "",
        manager: "",
        pickupMessage: "",
        deliveryMessage: "",
    });

    const [depart, setDepart] = useState({
        displayName: c_company || "",
        name: c_company || "",
        tel: "",
        manager: "",
        mobile: "",
        damCode: "",
        postcode: "",
        address: "",
        addressDetail: "",
        f_c_code: c_code || "",
        value: "",
        roll: "",
        box: "",
        sample: "",
        linkPrint: "",
    });
    const [arrive, setArrive] = useState({
        name: "",
        tel: "",
        manager: "",
        mobile: "",
        damCode: "",
        postcode: "",
        address: "",
        addressDetail: "",
        t_c_code: "",
    });

    const { data: arriveSearchData } = useGetOrderSearch(loginSearchInput);
    const { data: infoData } = useGetMypageInfo({
        enabled: isLoggedIn,
    });

    // useEffect(() => {
    //     // alert(JSON.stringify(infoData, null, 2));
    //     // alert("isLoggedIn" + isLoggedIn);
    // }, [isLoggedIn]);

    const { mutateAsync: uploadOrderFiles } = usePostOrderFile();
    const { mutate: postOrder } = usePostAddOrder(async responseData => {
        // 외부업체픽업접수 시 첨부파일 업로드
        if (pickupFiles.length > 0 && responseData?.data?.idx) {
            try {
                await uploadOrderFiles({
                    category: `order_tmp_${responseData.data.idx}`,
                    b_file: pickupFiles,
                    f_c_code: c_code ?? "",
                    f_company: c_company ?? "",
                });
            } catch (e) {
                console.error("파일 업로드 실패:", e);
            }
            setPickupFiles([]);
        }

        const savedReceipt = localStorage.getItem("morning-receipt");
        const parsedReceipt = savedReceipt ? JSON.parse(savedReceipt) : {};
        setErrorMessages({});
        setIsSubmitting(false);
        addressInfoRef.current?.resetCompanyNameChange?.();
        addressInfoRef.current?.clearErrors?.();

        setPayMethod({
            pickup: 1,
            payment: 1,
            count: "",
            weight: "",
            name: "",
            tel: "",
            manager: "",
            postcode: "",
            address: "",
            addressDetail: "",
            s_pay_company_code: "",
        });
        setReceipt({
            name: "",
            tel: c_code ? parsedReceipt.tel : "",
            department: "",
            departmentName: "",
            manager: c_code ? parsedReceipt.manager : "",
            pickupMessage: "",
            deliveryMessage: "",
        });

        const defaultCode = infoData?.c_addr_defalt ?? "1";
        const tel = { "1": c_tel, "2": c_rtel, "3": c_setel }[defaultCode] ?? "";
        const idx = Number(defaultCode) - 1;

        const addr1 = [infoData?.C_ADDR1, infoData?.C_RADDR1, infoData?.C_SeADDR1][idx];
        const addr2 = [infoData?.C_ADDR2, infoData?.C_RADDR2, infoData?.C_SeADDR2][idx];
        const postcode = [infoData?.C_Post, infoData?.C_RPost, infoData?.C_SePost][idx];

        setDepart({
            displayName: c_code ? (c_company ?? "") : "",
            name: c_code ? (c_company ?? "") : "",
            tel: c_code ? tel : "",
            manager: "",
            mobile: "",
            damCode: defaultCode,
            postcode: postcode ?? "",
            address: addr1 ?? "",
            addressDetail: addr2 ?? "",
            f_c_code: c_code ?? "",
            value: infoData
                ? infoData.c_addr_defalt === "1"
                    ? infoData.C_Branch
                    : infoData.c_addr_defalt === "2"
                      ? infoData.C_RBranch
                      : infoData.C_SeBranch
                : "01",
            roll: "",
            box: "",
            sample: "",
            linkPrint: "",
        });

        setArrive({
            name: "",
            tel: "",
            manager: "",
            mobile: "",
            damCode: "",
            postcode: "",
            address: "",
            addressDetail: "",
            t_c_code: "",
        });
        setIsArriveUseDefault(false);
    });
    const { mutate: postOrderAccept } = usePostOrderAccept(res => {
        navigate("/customer/online-order/complete", {
            state: { data: res.data },
        });
    });

    const { mutate: loginMutate } = usePostMasterLogin();
    const { data } = useGetLastOrder(triggerSearchTxt);

    const lastOrder = data?.order_list ?? [];

    const [activeSection, setActiveSection] = useState<string | null>(sections[0].id);
    const responsive1500 = useMediaQuery(1500);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessages, setErrorMessages] = useState<Record<string, string>>({});

    const validateFields = () => {
        const errors: Record<string, string> = {};
        if (!payMethod.count || payMethod.count.trim() === "") {
            errors.count = "수량을 입력하세요.";
        }
        if (!receipt.name || receipt.name.trim() === "") {
            errors.name = "상호명을 입력하세요.";
        }
        if (!receipt.tel || receipt.tel.trim() === "" || receipt.tel.length !== 13) {
            errors.tel = "연락처를 입력하세요.";
        }
        if (c_req_dept === "Y") {
            if (!receipt.departmentName || receipt.departmentName.trim() === "") {
                errors.departmentName = "부서명을 입력하세요.";
            }
        }

        if (!receipt.manager || payMethod.manager.trim() === "") {
            errors.manager = "담당자명을 입력하세요.";
        }
        // if (!depart.name || depart.name.trim() === "") {
        if (!depart.displayName || depart.displayName.trim() === "") {
            errors.departName = "상호명을 입력하세요.";
        }
        if (!depart.tel || depart.tel.trim() === "") {
            errors.departTel = "연락처를 입력하세요.";
        }
        if (!depart.postcode || depart.postcode.trim() === "") {
            errors.departPostcode = "출발지를 입력하세요.";
        }
        if (payMethod.pickup === 2 && depart.linkPrint === "Y" && (!depart.mobile || depart.mobile.trim() === "")) {
            errors.departMobile = "휴대폰번호를 입력하세요.";
        }

        if (!arrive.name || arrive.name.trim() === "") {
            errors.arriveName = "상호명을 입력하세요.";
        }
        if (!arrive.tel || arrive.tel.trim() === "") {
            errors.arriveTel = "연락처를 입력하세요.";
        }
        if (!arrive.postcode || arrive.postcode.trim() === "") {
            errors.arrivePostcode = "도착지를 입력하세요.";
        }

        return errors;
    };
    const handleOrderSubmit = () => {
        setIsSubmitting(true);
        const errors = validateFields();
        const errorKeys = Object.keys(errors);
        if (errorKeys.length > 0) {
            setErrorMessages(errors);
        }

        localStorage.setItem(
            "morning-receipt",
            JSON.stringify({
                tel: receipt.tel,
                manager: receipt.manager,
            }),
        );

        const isPayMethodValid = payMethodRef.current?.validate?.();
        const isReceiptValid = receiptRef.current?.validate?.();
        const isAddressInfoValid = addressInfoRef.current?.validate?.();

        if (!isPayMethodValid) {
            payMethodRef.current?.scrollIntoView?.({ behavior: "smooth" });
            return;
        }
        if (!isReceiptValid) {
            receiptRef.current?.scrollIntoView?.({ behavior: "smooth" });
            return;
        }
        if (!isAddressInfoValid) {
            addressInfoRef.current?.scrollIntoView?.({ behavior: "smooth" });
            return;
        }

        let damCode = depart.damCode;
        if (infoData && depart.damCode?.length !== 3) {
            if (depart.damCode === "1") {
                damCode = infoData.dcode;
            } else if (depart.damCode === "2") {
                damCode = infoData.dcode1;
            } else if (depart.damCode === "3") {
                damCode = infoData.dcode2;
            }
        }

        const defaultCBranch = "01"; // 기본값
        let c_branch = depart?.value ? (depart.value.trim() !== "" ? depart.value : defaultCBranch) : defaultCBranch;

        // 출발지 - 대구/경북: c_branch 02, 부산/경남: c_branch 04
        const postcodePrefix = depart?.postcode?.slice(0, 2);
        const prefix = postcodePrefix ? parseInt(postcodePrefix, 10) : null;

        if (prefix !== null) {
            if (prefix >= 36 && prefix <= 43) {
                c_branch = "02"; // 대구/경북
            } else if ((prefix >= 46 && prefix <= 49) || (prefix >= 50 && prefix <= 53)) {
                c_branch = "04"; // 부산/경남
            }
        }

        const payload = {
            c_code: c_code,
            sessionid: c_code ? "" : (guestSessionId ?? ""),
            c_branch: c_branch,
            c_req_dept: c_req_dept ?? "",
            s_kind: payMethod.pickup === 1 ? "H" : "A",
            s_pay_kind: String(payMethod.payment),
            s_cnt: payMethod.count,
            s_weight: payMethod.weight,
            // s_pay_company_code: payMethod.s_pay_company_code,
            s_pay_company_code:
                typeof payMethod.s_pay_company_code === "number" ||
                (typeof payMethod.s_pay_company_code === "string" && /^\d+$/.test(payMethod.s_pay_company_code))
                    ? payMethod.s_pay_company_code
                    : "",
            s_pay_company: payMethod.name,
            s_pay_tel: payMethod.tel,
            s_pay_name: payMethod.manager,
            s_pay_post: payMethod.postcode,
            s_pay_address: payMethod.address,
            s_pay_address_detail: payMethod.addressDetail,
            a_company: c_code ? c_company : receipt.name,
            a_tel: receipt.tel,
            a_part: c_code ? receipt.departmentName : receipt.departmentName,
            a_part_sn: c_code ? receipt.department : receipt.department,
            a_name: receipt.manager,
            a_request2: receipt.pickupMessage,
            a_request: receipt.deliveryMessage,
            f_c_code: depart.f_c_code,
            // f_company: depart.name || c_company,
            f_company: depart.displayName || c_company,
            f_tel: depart.tel,
            f_name: depart.manager,
            f_mobile: depart.mobile,
            f_post: depart.postcode,
            f_address: depart.address,
            f_address_detail: depart.addressDetail,
            f_dam_code: damCode,
            t_c_code: arrive.t_c_code,
            t_company: arrive.name,
            t_tel: arrive.tel,
            t_name: arrive.manager,
            t_mobile: arrive.mobile,
            t_post: arrive.postcode,
            t_address: arrive.address,
            t_address_detail: arrive.addressDetail,
            roll: depart.roll,
            box: depart.box,
            sample: depart.sample,
            ...(payMethod.pickup === 2 && depart.linkPrint === "Y" && { linkPrint: "Y" }),
        };

        // console.log("payload", payload);
        // return;
        // return;
        postOrder(payload);
    };

    const handleSubmit = () => {
        if (isHolidayBlocked) {
            alert(holidayBlockedMessage);
            return;
        }
        if (showAfter6PMOption && !deliveryType) {
            alert(`${closedTitle}에는 당일/익일 발송 중 하나를 선택해야 합니다.`);
            return;
        }
        setSubmitConfirm(true);
    };

    const handleSubmitConfirm = () => {
        if (isSubmittingOrder) return;

        setIsSubmittingOrder(true);
        const start = Date.now();

        const payload = {
            pcmobile: "pc",
            idx: selectedIdxList.map(String),
            six_order_flag: deliveryType === "today" ? "오후 6시 이후 접수 당일발송" : deliveryType === "tomorrow" ? "tomorrow" : "",
        };

        postOrderAccept(payload, {
            // 서버 차단(휴무일 403 등) 안내
            onError: (error: any) => alert(error?.response?.data?.message || "오더접수에 실패했습니다."),
            onSettled: () => {
                const elapsed = Date.now() - start;
                const remainingTime = 500 - elapsed;

                if (remainingTime > 0) {
                    setTimeout(() => setIsSubmittingOrder(false), remainingTime);
                } else {
                    setIsSubmittingOrder(false);
                }
            },
        });
    };

    const handleSearch = () => {
        setTriggerSearchTxt(searchTxt.trim());
    };
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };
    // 발송구분 변경 시 첨부파일 초기화
    useEffect(() => {
        if (payMethod.pickup !== 2) setPickupFiles([]);
    }, [payMethod.pickup]);

    useEffect(() => {
        if (!responsive1500) {
            const handleScroll = () => {
                const offset = 200;

                const visibleSections = sections
                    .map(section => {
                        const id = section.id;
                        const el = document.getElementById(id);
                        if (!el) return null;

                        const top = el.getBoundingClientRect().top;
                        return { id, top };
                    })
                    .filter(Boolean);

                const passedSections = visibleSections.filter(sec => sec!.top <= offset);
                const lastPassed = passedSections[passedSections.length - 1];

                if (lastPassed) {
                    setActiveSection(lastPassed.id);
                } else {
                    setActiveSection(sections[0].id);
                }
            };

            window.addEventListener("scroll", handleScroll);
            handleScroll();

            return () => window.removeEventListener("scroll", handleScroll);
        }
    }, [responsive1500]);

    useEffect(() => {
        const isMasterPath = location.pathname.includes("master");
        if (!isMasterPath) {
            logoutToGuest();
        }
        if (isMasterPath && morningStoreCCode !== "0300001") {
            navigate("/customer/online-order");
        }
    }, [location.pathname]);

    // 오더접수 마감 판정: 서버(휴무일·당일 업무 종료시간, KST) 기준. 조회 실패 시 기존 규칙(브라우저 18시 이후)
    useEffect(() => {
        if (!isBusinessDayFetched) return;

        let closed: boolean;
        if (businessDay) {
            const endTime = businessDay.day_end_time ?? "18:00";
            const holidayLabel = businessDay.reason === "weekend" ? "주말" : businessDay.holiday_name || "휴무일";
            const nowHHmm = businessDay.server_time.slice(11, 16);
            closed = businessDay.is_holiday || nowHHmm >= endTime;
            // 서버는 조기종료일에만 비휴무 + holiday_name 을 채운다
            const earlyName = !businessDay.is_holiday && businessDay.holiday_name ? businessDay.holiday_name : null;
            setClosedReason({ holiday: businessDay.is_holiday ? holidayLabel : null, earlyName, endTime });
        } else {
            const hour = new Date().getHours();
            closed = hour >= 18 && hour < 24;
            setClosedReason({ holiday: null, earlyName: null, endTime: "18:00" });
        }

        const isClosed = closed && !isDevMode;
        // 휴무일은 접수 자체가 불가 — 당일/익일 선택지 없이 안내만. 평일 마감 이후는 기존 흐름(선택 후 접수)
        setShowAfter6PMOption(isClosed && !(businessDay && businessDay.is_holiday));
        setShowCompletePop(isClosed);
    }, [isBusinessDayFetched, businessDay, isDevMode]);

    const closedTitle = closedReason.holiday
        ? `휴무일(${closedReason.holiday})`
        : closedReason.earlyName
          ? `조기 종료(${closedReason.endTime}, ${closedReason.earlyName}) 이후`
          : `업무 종료(${closedReason.endTime}) 이후`;
    const isHolidayBlocked = !!closedReason.holiday && !isDevMode;
    const holidayBlockedMessage = `오늘은 ${closedReason.holiday} 휴무일로 오더접수가 불가합니다. 영업일에 접수해 주세요.`;

    useEffect(() => {
        const isMember = !isMaster && !!accessToken;

        if (isMember && infoData) {
            const savedReceipt = localStorage.getItem("morning-receipt");
            const parsedReceipt = savedReceipt ? JSON.parse(savedReceipt) : {};

            setReceipt((prev: any) => ({
                ...prev,
                name: c_company,
                tel: parsedReceipt.tel ?? prev.tel,
                manager: parsedReceipt.manager ?? prev.manager,
            }));

            const defaultCode = infoData.c_addr_defalt ?? "1";
            const telMap = {
                "1": c_tel,
                "2": c_rtel,
                "3": c_setel,
            } as const;
            const tel = telMap[defaultCode as keyof typeof telMap] ?? "";

            setDepart(prev => ({
                ...prev,
                tel,
                damCode: defaultCode,
                value:
                    infoData.c_addr_defalt === "1"
                        ? infoData.C_Branch
                        : infoData.c_addr_defalt === "2"
                          ? infoData.C_RBranch
                          : infoData.C_SeBranch,
            }));
        }
    }, [infoData]);

    useEffect(() => {
        const guestAccess = location.state?.guest === true;
        if (!accessToken && !guestAccess) {
            navigate("/login", { replace: true });
        }
    }, [accessToken, location.state]);

    // 회원 기본 지점(c_addr_defalt) 주소 — 기본값 주입과 발송구분 전환에서 공통으로 사용한다.
    const getDefaultAddrInfo = useCallback(() => {
        if (!infoData) return null;

        const defaultCode = infoData.c_addr_defalt ?? "1";
        const idx = Number(defaultCode) - 1;

        return {
            defaultCode,
            address: [infoData.C_ADDR1, infoData.C_RADDR1, infoData.C_SeADDR1][idx] ?? "",
            addressDetail: [infoData.C_ADDR2, infoData.C_RADDR2, infoData.C_SeADDR2][idx] ?? "",
            postcode: [infoData.C_Post, infoData.C_RPost, infoData.C_SePost][idx] ?? "",
            tel: ({ "1": c_tel, "2": c_rtel, "3": c_setel } as any)[defaultCode] ?? "",
            value: [infoData.C_Branch, infoData.C_RBranch, infoData.C_SeBranch][idx] ?? "01",
        };
    }, [infoData, c_tel, c_rtel, c_setel]);

    // 당사픽업접수 출발지 = 회원 기본 주소
    const applyDepartDefault = useCallback(() => {
        const info = getDefaultAddrInfo();
        if (!info) return;

        setDepart({
            displayName: c_code ? (c_company ?? "") : "",
            name: c_code ? (c_company ?? "") : "",
            tel: c_code ? info.tel : "",
            manager: "",
            mobile: "",
            damCode: info.defaultCode,
            postcode: info.postcode,
            address: info.address,
            addressDetail: info.addressDetail,
            f_c_code: c_code ?? "",
            value: info.value,
            roll: "",
            box: "",
            sample: "",
            linkPrint: "",
        });
    }, [getDefaultAddrInfo, c_code, c_company]);

    // 회원 정보 로드 시 출발지 기본 주소를 1회만 주입하기 위한 플래그.
    // 사용자가 발송구분을 바꿨거나 최근 오더를 불러온 뒤라면 주입하지 않는다.
    const didInitDepart = useRef(false);

    // 발송구분(당사/외부) 라디오를 사용자가 직접 바꿨을 때에만 출발지·도착지를 초기화한다.
    // 이전에는 payMethod.pickup 을 의존성으로 둔 useEffect 가 이 역할을 했는데,
    // "최근 오더접수 가져오기 > 사용" 이 pickup 을 함께 바꾸면서 방금 채운 도착지를
    // 곧바로 다시 지워버렸다. (외부접수 건에서만 재현되던 원인)
    const handlePickupChange = (pickup: number) => {
        didInitDepart.current = true;
        setIsArriveUseDefault(false);

        if (pickup === 2) {
            // 외부업체픽업접수: 출발지는 직접 입력, 도착지 주소는 비운다
            setDepart({
                displayName: "",
                name: "",
                tel: "",
                manager: "",
                mobile: "",
                damCode: "",
                postcode: "",
                address: "",
                addressDetail: "",
                f_c_code: "",
                value: "",
                roll: "",
                box: "",
                sample: "",
                linkPrint: "",
            });
            setArrive(prev => ({ ...prev, damCode: "", tel: "", address: "", addressDetail: "", postcode: "" }));
        } else {
            // 당사픽업접수: 출발지는 회원 기본 주소로 되돌리고, 도착지는 전부 비운다
            applyDepartDefault();
            setArrive({
                name: "",
                tel: "",
                manager: "",
                mobile: "",
                damCode: "",
                postcode: "",
                address: "",
                addressDetail: "",
                t_c_code: "",
            });
        }
    };

    // 도착지 "접수자 정보와 동일" 을 켤 때 회원 기본 주소를 이어서 채운다.
    // (AddressInfo 의 handleSameToArrive 가 상호/담당자 등을 먼저 넣고 이 함수를 호출한다)
    const handleArriveUseDefaultChange = (value: boolean) => {
        setIsArriveUseDefault(value);
        if (!value) return;

        const info = getDefaultAddrInfo();
        if (!info) return;

        setArrive(prev => ({
            ...prev,
            damCode: info.defaultCode,
            tel: info.tel,
            address: info.address,
            addressDetail: info.addressDetail,
            postcode: info.postcode,
        }));
    };

    // 회원 정보를 처음 받아온 시점에 출발지 기본 주소를 1회만 주입한다.
    useEffect(() => {
        if (!infoData || didInitDepart.current) return;

        didInitDepart.current = true;
        if (payMethod.pickup === 1) applyDepartDefault();
    }, [infoData, payMethod.pickup, applyDepartDefault]);

    // console.log(payMethod.pickup === 2); // 외부픽업

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="인터넷오더접수" />
            <CustomerLayout>
                {isSubmittingOrder && <Spinner />}
                <div className="flex-1 bg-[#f8f8f8] flex flex-col items-center pt-12 responsive1200:bg-white responsive1200:pt-[30px]">
                    <p className="text-[#1b1c1e] text-[36px] font-bold responsive1200:text-[24px]">
                        {isMaster ? "Master오더접수" : "인터넷오더접수"}
                    </p>
                    {isMaster ? (
                        <div className="flex mt-3 p-10 rounded-2xl bg-white gap-5 w-full mx-auto max-w-[1200px] responsive1200:gap-0">
                            <SelectBox
                                className="bg-white w-full"
                                value={isGuest ? "1" : "2"}
                                onChange={val => {
                                    if (val === "1") {
                                        logoutToGuest();
                                        setLoginSearchInput("");
                                    }
                                }}
                                options={[
                                    { value: "1", label: "비회원" },
                                    { value: "2", label: "회원" },
                                ]}
                            />
                            <div className="relative w-full">
                                <Input
                                    placeholder="상호명을 직접 입력하거나 조회하세요."
                                    value={loginSearchInput}
                                    onChange={e => {
                                        setLoginSearchInput(e.target.value);
                                    }}
                                    className="w-full"
                                    onFocus={() => setArriveIsFocused(true)}
                                />
                                {arriveIsFocused && arriveSearchData && arriveSearchData.length > 0 && (
                                    <div className="absolute top-[56px] left-0 z-10 border bg-white rounded-lg shadow max-h-[400px] overflow-y-auto w-full">
                                        {arriveSearchData.map((company, idx) => (
                                            <div
                                                key={`${company.c_code}-${idx}`}
                                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-[16px]"
                                                onClick={() => {
                                                    loginMutate(
                                                        {
                                                            c_code: company.c_code,
                                                            c_company_number: company.c_company_number,
                                                        },
                                                        {
                                                            onSuccess: () => {
                                                                loginAsMember({
                                                                    c_code: company.c_code,
                                                                    c_company: company.C_Company,
                                                                    c_company_number: company.c_company_number,
                                                                });
                                                                setLoginSearchInput(company.C_Company);
                                                                setArriveIsFocused(false);
                                                            },
                                                            onError: () => {
                                                                alert("로그인에 실패했습니다. 정보를 확인해주세요.");
                                                            },
                                                        },
                                                    );
                                                }}
                                            >
                                                {company.display_info}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        c_code && (
                            <div
                                onClick={() => setRecentOrderShow(true)}
                                className="cursor-pointer py-[10px] px-[20px] gap-1 flex justify-center items-center bg-white rounded-lg mt-4 text-[#878a93] border text-[18px] font-semibold"
                            >
                                <RecentFile />
                                <p>최근 오더접수 가져오기</p>
                            </div>
                        )
                    )}

                    <div className="flex responsive1500:translate-x-0 -translate-x-[75px] justify-center w-full my-10 gap-5 responsive1200:gap-0">
                        <div
                            className="w-[120px] responsive1500:hidden"
                            style={{
                                position: "sticky",
                                top: "150px",
                                alignSelf: "flex-start",
                                zIndex: 20,
                                height: "fit-content",
                            }}
                        >
                            {sections.map((section, index) => {
                                const isActive = activeSection === section.id;
                                return (
                                    <div
                                        key={index}
                                        className={`w-[120px] h-[120px] flex justify-center items-center gap-[10px] flex-col cursor-pointer border ${
                                            isActive
                                                ? "bg-[#ff7b2e] text-white border-transparent"
                                                : "bg-white text-[#1b1c1e] border-[#e1e2e4]"
                                        }`}
                                        onClick={() => {
                                            const target = document.getElementById(section.id);
                                            if (target) {
                                                target.style.scrollMarginTop = "120px";
                                                target.scrollIntoView({ behavior: "smooth" });
                                            }
                                        }}
                                    >
                                        <span className="text-[24px] font-[700]">0{index + 1}</span>
                                        <p className="whitespace-pre-line text-center text-[18px] font-[500]">{section.title}</p>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="w-full max-w-[1200px] flex flex-col gap-7">
                            <PayMethod
                                onPickupChange={handlePickupChange}
                                ref={payMethodRef}
                                id={sections[0].id}
                                master={isMaster}
                                data={payMethod}
                                setData={setPayMethod}
                                errorMessages={errorMessages}
                                isSubmitting={isSubmitting}
                                infoData={infoData}
                            />
                            <ReceiptInfo
                                ref={receiptRef}
                                id={sections[1].id}
                                master={isMaster}
                                data={receipt}
                                setData={setReceipt}
                                errorMessages={errorMessages}
                                isSubmitting={isSubmitting}
                            />
                            <AddressInfo
                                isArriveUseDefault={isArriveUseDefault}
                                setIsArriveUseDefault={handleArriveUseDefaultChange}
                                pickup={payMethod.pickup === 2}
                                receiptData={receipt}
                                infoData={infoData}
                                ref={addressInfoRef}
                                id={sections[2].id}
                                depart={depart}
                                setDepart={setDepart}
                                arrive={arrive}
                                setArrive={setArrive}
                                master={isMaster}
                                errorMessages={errorMessages}
                                isSubmitting={isSubmitting}
                                payMethodData={payMethod}
                                onWeightChange={(weight: string) => setPayMethod(prev => ({ ...prev, weight }))}
                                c_month_yn={c_month_yn}
                                pickupFiles={pickupFiles}
                                onPickupFilesChange={setPickupFiles}
                            />
                            <div className="flex flex-col items-center gap-2 mb-7 responsive1200:px-[16px]">
                                <button
                                    onClick={handleOrderSubmit}
                                    className="bg-[#132E47] text-white w-[600px] text-[20px] font-bold py-[15px] rounded-lg responsive1200:w-full"
                                >
                                    현재 입력한 정보 오더접수 추가
                                </button>
                                <p className="text-[#5A5C63] break-keep text-center responsive1200:text-[14px]">
                                    오더접수 목록에 추가하시면 다수의 오더접수를 동시에 등록할 수 있습니다.
                                </p>
                            </div>
                            <OrderList infoData={infoData} code={c_code} onSelectRowsChange={setSelectedIdxList} id={sections[3].id} />
                            <div className="flex w-full max-w-[1200px] flex-col gap-3 mt-8 responsive1200:px-[16px]">
                                <div
                                    className="flex flex-col bg-[#feeee5] rounded-2xl  responsive1200:p-[16px]"
                                    onClick={() => setCheckedTerms(prev => !prev)}
                                >
                                    <div className="flex items-center w-full py-5 px-10 cursor-pointer responsive1200:p-0">
                                        <CheckBox size="w-10 h-10" checked={checkedTerms} />
                                        <p className="text-new font-bold text-[20px] pl-0.5 responsive1200:text-[18px]">[필수]</p>
                                        <p className="text-[#1b1c1e] font-semibold text-[20px] pl-1.5 responsive1200:text-[18px]">
                                            택배 운송 약관
                                        </p>
                                        <DownArrow
                                            onClick={e => {
                                                e.stopPropagation();
                                                setShowTermsContent(prev => !prev);
                                            }}
                                            className="ml-auto"
                                        />
                                    </div>

                                    <div
                                        className={`terms-transition ${
                                            showTermsContent ? "open mb-10" : ""
                                        } text-[15px] mx-12 text-[#222] whitespace-pre-wrap leading-relaxed`}
                                    >
                                        {`공정거래 위원회 택배표준약관
    표준약관 제10026호
    (2020. 6. 5. 개정)

    [제 1 장 총칙]
    제 1 조 (목적)
    이 약관은 택배사업자와 고객(송화인) 간의 공정한 택배거래를 위하여 그 계약조건을 정함을 목적으로 합니다.

    제 2 조 (용어의 정의)
    ① ‘택배’라 함은 고객의 요청에 따라 운송물을 고객(송화인)의 주택, 사무실 또는 기타의 장소에서 수탁하여 고객(수화인)의 주택, 사무실 또는 기타의 장소까지 운송하여 인도하는 것을 말합니다.
    ② ‘배사업자’(이하 ‘사업자’라 합니다)라 함은 택배를 영업으로 하며, 상호가운송장에 기재된 운송사업자를 말합니다.
    ③ ‘고객’이라 함은 사업자에게 택배를 보내는 송화인과 받는 수화인을 말합니다. 다만, 약관의규제에관한법률에 따른 ‘고객’은 ‘송화인’을 말합니다.
    ④ ‘송화인’이라 함은 사업자와 택배계약을 체결한 자로 운송장에 ‘보내는 자’(또는 ‘보내는 분’)로 명시되어 있는 자를 말합니다.
    ⑤ ‘수화인’이라 함은 운송물을 수령하는 자로 운송장에 ‘받는 자’(또는 ‘받는분’)로 명시되어 있는 자를 말합니다.
    ⑥ ‘운송장’이라 함은 사업자와 고객(송화인) 간의 택배계약의 성립과 내용을 증명하기 위하여 사업자의 청구에 의하여 고객(송화인)이 발행한 문서를 말합니다.
    ⑦ ‘수탁’이라 함은 사업자가 택배를 수행하기 위하여 고객(송화인)으로부터 운송물을 수령하는 것을 말합니다.
    ⑧ ‘인도’라 함은 사업자가 고객(수화인)에게 운송장에 기재된 운송물을 넘겨주는 것을 말합니다.
    ⑨ ‘손해배상한도액’이라 함은 운송물의 멸실, 훼손 또는 연착 시에 사업자가 손해를 배상할 수 있는 최고 한도액을 말합니다. 다만, ‘손해배상한도액’은 고객(송화인)이 운송장에 운송물의 가액을 기재하지 아니한 경우에 한하여 적용되며, 사업자는 손해배상한도액을 미리 이 약관의 별표로 제시하고 운송장에 기재합니다.

    제 3 조 (약관의 명시 및 설명)
    ① 사업자는 이 약관을 사업장에 게시하며, 택배계약(이하 ‘계약’이라 합니다)을체결하는 때에 고객(송화인, 수화인)의 요구가 있으면 이를 교부합니다.
    ② 사업자는 계약을 체결하는 때에 고객(송화인)에게 다음 각 호의 사항을 설명합니다.
    1. 고객(송화인)이 운송장에 운송물의 가액을 기재하면 사업자의 손해배상 시 그 가액이 손해배상액의 산정기준이 된다는 사항
    2. 고객(송화인)이 운송장에 운송물의 가액을 기재하지 아니하면 사업자의 손해배상 시 제22조 제3항의 손해배상한도액 내에서만 손해배상을 한다는 사항
    3. 운송물의 기본운임 정보, 품목별 할증운임 정보, 배송지역 특성에 따른 부가운임 정보 및 운송물 가액에 따른 손해배상한도액 정보 등에 대한 사항 
    ③ 사업자가 제1항 및 제2항의 규정에 위반하여 계약을 체결한 때에는 당해 약관규정을 계약의 내용으로 주장할 수 없습니다.

    제4조(적용법규등)
    이 약관에 규정되지 않은 사항에 대하여는 화물자동차운수사업법, 상법 등의 법규와 공정한 일반관습에 따릅니다.
    [제 2 장 운송물의 수탁]

    제 5 조 (사업자의 의무)
    ① 사업자는 택배를 이용하고자 하는 자에게 다음 각 호의 사항을 홈페이지 및 모바일 앱, 콜센터, 전화 등으로 알기 쉽게 제공하여야 합니다.
    1. 택배의 접수방법, 취소, 환불, 변경방법
    2. 택배사고 시 배상접수 방법 및 배상기준, 처리절차 등
    3. 송장번호 입력란
    4. 결제방법
    5. 택배이용약관 또는 운송계약서
    ② 사업자는 고객응대시스템(콜센터, 어플리케이션 등)을 설치, 운영하여야 하며 고객서비스 만족 수준을 제고시키기 위해 노력하여야 합니다.
    ③ 사업자는 업무상 알게 된 고객(송화인, 수화인)의 개인정보를 개인정보보호법 등 관계법령에 따라 관리하여야 하며, 고객(송화인, 수화인)의 동의 없이 택배업무와 관계없는 제3자에게 제공할 수 없습니다.
    ④ 위 사항 이외에도 사업자는 대행 업무를 수행함에 있어 선량한 관리자로서의 주의와 의무를 다하여야 합니다.

    제 6 조 (송화인의 의무)
    ① 고객(송화인)은 수화인의 주소, 전화번호, 성명, 운송물의 품명 및 표준가액 등을 운송장에 정확하게 작성하여야 합니다.
    ② 고객(송화인)은 제12조에 의한 규정에 따라 화약류, 인화물질, 밀수품, 군수품, 현금, 카드, 어음, 수표, 유가증권, 계약서, 원고, 서류, 동물, 동물사체 등의 운송물을 위탁하지 않아야 합니다.

    제 7 조 (운송장)
    ① 사업자는 계약을 체결하는 때에 다음 각 호의 사항을 기재한 운송장을 마련하여 고객(송화인)에게 교부합니다.
    1. 사업자의 상호, 대표자명, 주소 및 전화번호, 담당자(집화자) 이름, 운송장번호
    2. 운송물을 수탁한 당해 사업소(사업자의 본?지점, 출장소 등)의 상호, 대표자명, 주소 및 전화번호
    3. 운송물의 중량 및 용적 구분
    4. 운임 기타 운송에 관한 비용 및 지급방법
    5. 손해배상한도액
    ※고객(송화인)이 운송장에 운송물의 가액을 기재하지 아니하면 제22조 제3항에 따라 사업자가 손해배상을 할 경우 손해배상한도액은 50만원이 적용되고, 운송물의 가액에 따라 할증요금을 지급하는 경우에는 각 운송가액 구간별 최고가액이 적용됨을 명시해 놓을 것
    6. 문의처 전화번호
    7. 운송물의 인도 예정 장소 및 인도 예정일
    8. 기타 운송에 관하여 필요한 사항(특급배송, 신선식품 배송 등)
    ② 고객(송화인)은 제1항의 규정에 의하여 교부받은 운송장에 다음 각 호의 사항을 기재하고 기명날인 또는 서명하여 이를 다시 사업자에게 교부합니다.
    1. 송화인의 주소, 이름(또는 상호) 및 전화번호
    2. 수화인의 주소, 이름(또는 상호) 및 전화번호
    3. 운송물의 종류(품명), 수량 및 가액
    ※ 고객(송화인)이 운송장에 운송물의 가액을 기재하면 사업자가 손해배상을 할 경우 이 가액이 손해배상액 산정의 기준이 된다는 점을 명시해 놓을 것
    4. 운송물의 인도예정장소 및 인도예정일(특정 일시에 수하인이 사용할 운송물의 경우에는 그 사용목적, 특정 일시 및 인도예정일시를 기재함)
    5. 운송상의 특별한 주의사항(훼손, 변질, 부패 등 운송물의 특성구분과 기타 필요한 사항을 기재함)
    6. 운송장의 작성연월일

    제 8 조 (운임의 청구와 유치권)
    ① 사업자는 운송물을 수탁할 때 고객(송화인)에게 운임을 청구할 수 있습니다. 다만, 고객(송화인)과의 합의에 따라 운송물을 인도할 때 운송물을 받는 자(수화인)에게 청구할 수도 있습니다.
    ② 제1항 단서의 경우 고객(수화인)이 운임을 지급하지 않는 때에는 사업자는 운송물을 유치할 수 있습니다.
    ③ 운송물이 포장 당 50만원을 초과하거나 운송상 특별한 주의를 요하는 것일때에는 사업자는 따로 할증요금을 청구할 수 있습니다.
    ④ 고객(송화인, 수화인)의 사유로 운송물을 돌려보내거나, 도착지 주소지가 변경되는 경우, 사업자는 따로 추가 요금을 청구할 수 있습니다.
    ⑤ 운임 및 할증요금은 미리 이 약관의 별표로 제시하고 운송장에 기재합니다.

    제 9 조 (포장)
    ① 고객(송화인)은 운송물을 그 성질, 중량, 용적 등에 따라 운송에 적합하도록 포장하여야 합니다.
    ② 사업자는 운송물의 포장이 운송에 적합하지 아니한 때에는 고객(송화인)에게 필요한 포장을 하도록 청구하거나, 고객(송화인)의 승낙을 얻어 운송 중 발생될 수 있는 충격량을 고려하여 포장을 하여야 합니다. 다만, 이 과정에서 추가적인 포장비용이 발생할 경우에는 사업자는 고객(송화인)에게 추가 요금을 청구할 수 있습니다.
    ③ 사업자는 제2항의 규정을 준수하지 아니하여 발생된 사고 시 제22조에 의해 고객(송화인)에게 손해배상을 하여야 합니다.
    ④ 사업자가 운송물을 운반하는 도중 운송물의 포장이 훼손되어 재포장을 한 경우에는 지체 없이 고객(송화인)에게 그 사실을 알려야 합니다.

    제 10 조 (외부표시)
    사업자는 운송물을 수탁한 후 그 포장의 외부에 운송물의 종류?수량, 운송 상의 특별한 주의사항, 인도 예정일(시) 등의 필요한 사항을 표시합니다.

    제 11 조 (운송물의 확인)
    ① 사업자는 운송장에 기재된 운송물의 종류와 수량에 관하여 고객(송화인)의 동의를 얻어 그 참여 하에 이를 확인할 수 있습니다.
    ② 사업자가 제1항의 규정에 의하여 운송물을 확인한 경우에 운송물의 종류와 수량이 고객(송화인)이 운송장에 기재한 것과 같은 때에는 사업자가 그로 인하여 발생한 비용 또는 손해를 부담하며, 다른 때에는 고객(송화인)이 이를 부담합니다.

    제 12 조 (운송물의 수탁거절)
    사업자는 다음 각 호의 경우에 운송물의 수탁을 거절할 수 있습니다.
    1. 고객(송화인)이 운송장에 필요한 사항을 기재하지 아니한 경우
    2. 고객(송화인)이 제9조 제2항의 규정에 의한 청구나 승낙을 거절하여 운송에 적합한 포장이 되지 않은 경우
    3. 고객(송화인)이 제11조 제1항의 규정에 의한 확인을 거절하거나 운송물의 종류와 수량이 운송장에 기재된 것과 다른 경우
    4. 운송물 1포장의 크기가 가로?세로?높이 세변의 합이 ( )cm를 초과하거나, 최장변이 ( )cm를 초과하는 경우
    5. 운송물 1포장의 무게가 ( )kg를 초과하는 경우
    6. 운송물 1포장의 가액이 300만원을 초과하는 경우
    7. 운송물의 인도예정일(시)에 따른 운송이 불가능한 경우
    8. 운송물이 화약류, 인화물질 등 위험한 물건인 경우
    9. 운송물이 밀수품, 군수품, 부정임산물 등 관계기관으로부터 허가되지 않거나 위법한 물건인 경우
    10. 운송물이 현금, 카드, 어음, 수표, 유가증권 등 현금화가 가능한 물건인 경우
    11. 운송물이 재생 불가능한 계약서, 원고, 서류 등인 경우
    12. 운송물이 살아 있는 동물, 동물사체 등인 경우
    13. 운송이 법령, 사회질서 기타 선량한 풍속에 반하는 경우
    14. 운송이 천재, 지변 기타 불가항력적인 사유로 불가능한 경우
    [제 3 장 운송물의 인도]

    제13조(공동운송 또는 타운송수단의 이용)
    사업자는 고객(송화인)의 이익을 해치지 않는 범위 내에서 수탁한 운송물을 다른 운송사업자와 협정을 체결하여 공동으로 운송하거나 다른 운송사업자의 운송수단을 이용하여 운송할 수 있습니다.

    제 14 조 (운송물의 인도일)
    ① 사업자는 다음 각 호의 인도예정일까지 운송물을 인도합니다.
    1. 운송장에 인도 예정일의 기재가 있는 경우에는 그 기재된 날
    2. 운송장에 인도 예정일의 기재가 없는 경우에는 운송장에 기재된 운송물의 수탁일로부터 인도예정 장소에 따라 다음 일수에 해당하는 날
    가. 일반 지역 : 수탁일로부터 2일
    나. 도서, 산간벽지 : 수탁일로부터 3일
    ② 사업자는 수화인이 특정 일시에 사용할 운송물을 수탁한 경우에는 운송장에 기재된 인도예정일의 특정 시간까지 운송물을 인도합니다.
    ③ 사업자는 고객(수화인)에 인도후 운송물 배송의 배송완료 일시, 송장번호 등 을 고객(송화인)이 확인할 수 있도록 협력하여야 합니다.

    제 15 조 (수하인 부재시의 조치)
    ① 사업자는 운송물의 인도 시 고객(수화인)으로부터 인도확인을 받아야 하며, 고객(수화인)의 대리인에게 운송물을 인도하였을 경우에는 고객(수화인)에게 그 사실을 통지합니다.
    ② 사업자는 고객(수화인)의 부재로 인하여 운송물을 인도할 수 없는 경우에는 고객(송화인/수화인)과 협의하여 반송하거나, 고객(송화인/수화인)의 요청시 고 객(송화인/수화인)과 합의된 장소에 보관하게 할 수 있으며, 이 경우 고객(수화 인)과 합의된 장소에 보관하는 때에는 고객(수화인)에 인도가 완료된 것으로 합 니다.
    [제 4 장 운송물의 처분]

    제 16 조 (인도할 수 없는 운송물의 처분)
    ① 사업자는 고객(수화인)을 확인할 수 없거나(수화인 불명), 고객(수화인)이 운 송물의 수령을 거절하거나(수령거절) 수령할 수 없는 경우(수령불능)에는, 운송 물을 공탁하거나 제2항 내지 제4항의 규정에 의하여 경매할 수 있습니다.
    ② 사업자는 고객(송화인)에게 1개월 이상의 기간을 정하여 그 기간 내에 운송 물의 처분에 관한 지시가 없으면 경매한다는 뜻을 명시하여 운송물의 처분과 관련한 지시를 해 줄 것을 통지합니다. 다만, 고객(수화인)의 수령거절 또는 수 령불능의 경우에는 먼저 고객(수화인)에게 1주일 이상의 기간을 정하여 수령을 요청하고 그 기간 내에도 수령하지 않는 때에 고객(송화인)에게 통지합니다.
    ③ 사업자는 제2항의 규정에 의한 통지가 고객(송화인)에게 도달된 것으로 확인 되는 경우에는, 그 도달일로부터 정한 기간 내에 지시가 없으면 운송물을 경매 할 수 있습니다. 그러나 통지가 사업자의 과실 없이 고객(송화인)에게 도달된 것으로 확인될 수 없는 경우에는, 통지를 발송한 날로부터 3개월간 운송물을 보 관한 후에 경매할 수 있습니다.
    ④ 사업자는 운송물이 멸실 또는 훼손될 염려가 있는 경우에는, 고객(송화인, 수화인)의 이익을 위해 고객(송화인, 수화인)에 대한 통지 없이 즉시 경매할 수 있습니다.
    ⑤ 사업자가 운송물을 공탁 또는 경매한 때에는 지체 없이 그 사실을 고객(송화 인)에게 통지합니다.
    ⑥ 제1항 내지 제5항의 규정에 의한 운송물의 공탁·경매·보관, 통지, 고객(송 화인)의 지시에 따른 운송물의 처분 등에 소요되는 비용은 고객(송화인)의 부담 으로 하며, 사업자는 운임이 지급되지 않은 경우에는 고객(송화인)에게 운임을 청구할 수 있습니다.
    ⑦ 사업자는 운송물을 경매한 때에는 그 대금을 운송물의 경매·보관, 통지 등 에 소요되는 비용과 운임(운임이 지급되지 않은 경우에 한함)에 충당하고, 부족 한 때에는 고객(송화인)에게 그 지급을 청구하며, 남는 때에는 고객(송화인)에게 반환합니다. 이 경우 고객(송화인)에게 반환해야 할 잔액을 고객(송화인)이 수령 하지 않거나 수령할 수 없는 때에는, 공탁에 과다한 비용이 소요되지 않는 한, 그 금액을 공탁합니다.

    제 17 조 (고객의 처분청구권)
    ① 고객(송화인)은 사업자에 대하여 운송의 중지, 운송물의 반환 등의 처분을 청구할 수 있습니다.
    ② 사업자는 제1항의 규정에 의한 고객(송화인)의 청구가 있는 때에는, 공동운 송 또는 타 운송수단의 이용 등으로 인해 운송상 현저한 지장이 발생할 우려가 있는 경우를 제외하고는 이에 응합니다. 이 경우에 이미 운송한 비율에 따른 운 임과 운송물의 처분에 소요되는 비용은 고객(송화인)의 부담으로 합니다.
    ③ 제1항의 규정에 의한 고객(송화인)의 청구권은 고객(수화인)에게 운송물을 인도한 때에 소멸합니다.
    [제 5 장 운송물의 사고]

    제 18 조 (사고발생시의 조치)
    ① 사업자는 운송물의 수탁 후부터 인도전까지 전부 멸실을 발견한 때에는 지 체 없이 그 사실을 고객(송화인)에게 통지합니다.
    ② 사업자는 운송물의 수탁 후부터 인도전까지 운송물의 일부 멸실이나 현저한 훼손을 발견하거나, 인도 예정일 보다 현저하게 연착될 경우에는 지체 없이 그 사실을 고객(송화인)에게 통지하고, 일정 기간을 정하여 운송물의 처분 방법 및 일자 등에 관한 지시를 해 줄 것을 요청합니다.
    ③ 사업자는 제2항의 규정에 의한 고객(송화인)의 지시를 기다릴 여유가 없는 경우 또는 사업자가 정한 기간 내에 지시가 없을 경우에는 고객의 이익을 위하 여 운송의 중지, 운송물의 반환 기타의 필요한 처분을 할 수 있습니다. 이 경우 사업자는 지체 없이 그 사실을 고객(송화인)에게 통지합니다.

    제 19 조 (사고증명서의 발행)
    사업자는 운송 중에 발생한 운송물의 멸실, 훼손 또는 연착에 대하여 고객(송화인)의 청구가 있으면 그 발생한 날로부터 1년에 한하여 사고증명서를 발행합니다.
    [제 6 장 사업자의 책임]

    제 20 조(책임의 시작)
    운송물의 멸실, 훼손 또는 연착에 관한 사업자의 책임은 운송물을 고객(송화인)으로부터 수탁한 때로부터 시작됩니다.

    제 21 조(공동운송 또는 타운송수단 이용시 책임)
    사업자가 다른 운송사업자와 협정을 체결하여 공동으로 운송하거나 다른 운송사업자의 운송수단을 이용하여 운송한 운송물이 멸실, 훼손 또는 연착되는 때에는 이에 대한 책임은 사업자가 부담합니다.

    제 22 조(손해배상)
    ① 사업자는 자기 또는 운송 위탁을 받은 자, 기타 운송을 위하여 관여된 자가 운송물의 수탁, 인도, 보관 및 운송에 관하여 주의를 태만히 하지 않았음을 증 명하지 못하는 한, 제2항 내지 제4항의 규정에 의하여 운송물의 멸실, 훼손 또 는 연착으로 인한 손해를 고객(송화인)에게 배상합니다.
    ② 고객(송화인)이 운송장에 운송물의 가액을 기재한 경우에는 사업자의 손해배 상은 다음 각 호에 의합니다.
    1. 전부 또는 일부 멸실된 때: 운송장에 기재된 운송물의 가액을 기준으로 산정한 손해액 또는 고객(송화인)이 입증한 운송물의 손해액(영수증 등)
    2. 훼손된 때
    가. 수선이 가능한 경우 : 실수선 비용(A/S비용)
    나. 수선이 불가능한 경우 : 제1호에 준함
    3. 연착되고 일부 멸실 및 훼손되지 않은 때
    가. 일반적인 경우 : 인도예정일을 초과한 일수에 사업자가 운송장에 기재한 운임액(이하 ‘운송장 기재 운임액'이라 합니다)의 50%를 곱한 금액(초과일수 ×운송장 기재 운임액×50%). 다만, 운송장 기재 운임액의 200%를 한도로 함
    나. 특정 일시에 사용할 운송물의 경우 : 운송장기재운임액의 200
    4. 연착되고 일부 멸실 또는 훼손된 때: 제1호 또는 제2호에 준함
    ③ 고객(송화인)이 운송장에 운송물의 가액을 기재하지 않은 경우에는 사업자의 손해배상은 다음 각 호에 의합니다. 이 경우 손해배상한도액은 50만원으로 하되, 운송물의 가액에 따라 할증요금을 지급하는 경우의 손해배상한도액은 각 운송가액 구간별 운송물의 최고가액으로 합니다.
    1. 전부 멸실된 때 : 인도예정일의 인도예정장소에서의 운송물 가액을 기준으로 산정한 손해액 또는 고객(송화인)이 입증한 운송물의 손해액(영수증 등)
    2. 일부 멸실된 때 : 인도일의 인도장소에서의 운송물 가액을 기준으로 산정한 손해액 또는 고객(송화인)이 입증한 운송물의 손해액(영수증 등)
    3. 훼손된 때
    가. 수선이 가능한 경우 : 실수선 비용(A/S비용)
    나. 수선이 불가능한 경우 : 제2호에 준함
    4. 연착되고 일부 멸실 및 훼손되지 않은 때 : 제2항 제3호를 준용함
    5. 연착되고 일부 멸실 또는 훼손된 때 : 제2호 또는 제3호에 준하되, ‘인도일'을 '인도예정일'로함
    ④ 운송물의 멸실, 훼손 또는 연착이 사업자 또는 운송 위탁을 받은 자, 기타 운송을 위하여 관여된 자의 고의 또는 중대한 과실로 인하여 발생한 때에는, 사업자는 제2항과 제3항의 규정에도 불구하고 모든 손해를 배상합니다.
    ⑤ 제1항에 따른 손해에 대하여 사업자가 고객(송화인)으로부터 배상요청을 받은 경우 고객(송화인)이 영수증 등 제2항 내지 제4항에 따른 손해입증서류를 제출한 날로부터 30일 이내에 사업자가 우선 배상합니다. 단, 손해입증서류가 허위인 경우에는 적용되지 아니합니다.

    제 23 조(사고발생시의 운임등의 환급과 청구)
    ① 운송물의 멸실, 현저한 훼손 또는 연착이 천재지변, 전쟁, 내란 기타 불가항 력적인 사유 또는 고객(송화인, 수화인)의 책임없는 사유로 인한 것인 때에는, 사업자는 운임을 비롯하여 제18조 제1항 내지 제3항의 규정에 의한 통지, 합의, 처분 등에 소요되는 비용을 청구하지 못합니다. 사업자가 이미 운임이나 비용을 받은 때에는 이를 환급합니다.
    ② 운송물의 멸실, 현저한 훼손 또는 연착이 운송물의 성질이나 하자 또는 고객 (송화인, 수화인)의 과실로 인한 것인 때에는, 사업자는 운임 전액을 비롯하여 제18조 제1항 내지 제3항의 규정에 의한 통지, 협의, 처분 등에 소요되는 비용 을 청구할 수 있습니다.

    제 24 조(사업자의 면책)
    사업자는 천재지변, 전쟁, 내란 기타 불가항력적인 사유에 의하여 발생한 운송물의 멸실, 훼손 또는 연착에 대해서는 손해배상책임을 지지 아니합니다.

    제 25 조 (책임의 특별소멸사유와 시효)
    ① 운송물의 일부 멸실 또는 훼손에 대한 사업자의 손해배상책임은 고객(수화 인)이 운송물을 수령한 날로부터 14일 이내에 그 일부 멸실 또는 훼손에 대한 사실을 고객(송화인)이 사업자에게 통지를 발송하지 아니하면 소멸합니다.
    ② 운송물의 일부 멸실, 훼손 또는 연착에 대한 사업자의 손해배상책임은 고객 (수화인)이 운송물을 수령한 날로부터 1년이 경과하면 소멸합니다. 다만, 운송물 이 전부 멸실된 경우에는 그 인도예정일로부터 기산합니다.
    ③ 제1항과 제2항의 규정은 사업자 또는 그 운송 위탁을 받은 자, 기타 운송을 위하여 관여된 자가 이 운송물의 일부 멸실 또는 훼손의 사실을 알면서 이를 숨기고 운송물을 인도한 경우에는 적용되지 아니합니다. 이 경우에는 사업자의 손해배상책임은 고객(수화인)이 운송물을 수령한 날로부터 5년간 존속합니다.

    제 26 조 (분쟁해결)
    ① 이 계약에 명시되지 아니한 사항 또는 계약의 해석에 관하여 다툼이 있는 경우에는 사업자와 고객(송화인)이 합의하여 결정하되, 합의가 이루어지지 아니 한 경우에는 관계법령 및 일반 관례에 따릅니다.
    ② 제1항의 규정에도 불구하고 법률상 분쟁이 발생한 경우에는 사업자 또는 고 객(송화인)은 소비자기본법에 따른 분쟁조정기구에 분쟁조정을 신청하거나 중재 법 등 다른 법률에 따라 운영 중인 중재기관에 중재를 신청할 수 있습니다.
    ③ 이 계약과 관련된 모든 분쟁은 민사소송법상의 관할법원을 전속관할로 합니다.`}
                                    </div>
                                </div>
                                <div
                                    className="flex flex-col bg-[#feeee5] w-full py-5 px-10 rounded-2xl gap-1 cursor-pointer responsive1200:p-[16px]"
                                    onClick={() => setCheckedNotice(prev => !prev)}
                                >
                                    <div className="flex items-center">
                                        <CheckBox size="w-10 h-10" checked={checkedNotice} />
                                        <p className="text-new font-bold text-[20px] pl-0.5 responsive1200:text-[18px]">
                                            [필수] {closedTitle}
                                        </p>
                                        <p className="text-[#1b1c1e] font-semibold text-[20px] pl-1.5 responsive1200:text-[18px]">
                                            오더접수건
                                        </p>
                                    </div>
                                    <div className="flex items-center text-[#222] gap-4 ml-2">
                                        <div className="bg-white rounded-full shrink-0">
                                            <img src={After1} alt="After1" />
                                        </div>
                                        <p>
                                            {isHolidayBlocked
                                                ? "휴무일에는 오더접수(송장출력)가 불가합니다. 영업일에 접수해 주세요."
                                                : "오더접수가 마감되어 송장출력만 가능하오니 출력 후 발송(픽업) 가능 여부는 해당 픽업담당자분께 문의 바랍니다."}
                                        </p>
                                    </div>
                                    <div className="flex items-center text-[#222] gap-4 mt-1.5 ml-2">
                                        <div className="bg-white rounded-full shrink-0">
                                            <img src={After2} alt="After2" />
                                        </div>
                                        <p>18시 이전 픽업 접수한 물품이 수령 전일 땐 추가 출력하여 같이 두시면 발송됩니다.</p>
                                    </div>
                                </div>
                                {showAfter6PMOption && (
                                    <div className="flex items-center bg-[#feeee5] w-full py-5 px-10 rounded-2xl cursor-pointer responsive1200:p-[16px]">
                                        <div onClick={() => setDeliveryType("today")} className="flex items-center gap-2 cursor-pointer">
                                            <CheckBox size="w-10 h-10" checked={deliveryType === "today"} />
                                            <p className="text-[#1b1c1e] font-semibold text-[20px] pl-0.5 responsive1200:text-[18px]">
                                                픽업전 추가 출력, 담당자 승인 출력
                                            </p>
                                            <p className="text-new font-bold text-[20px] pl-1.5 responsive1200:text-[18px] mr-20">
                                                (당일발송)
                                            </p>
                                        </div>
                                        <div onClick={() => setDeliveryType("tomorrow")} className="flex items-center gap-2 cursor-pointer">
                                            <CheckBox size="w-10 h-10 " checked={deliveryType === "tomorrow"} />
                                            <p className="text-[#1b1c1e] font-semibold text-[20px] pl-0.5 responsive1200:text-[18px]">
                                                출력후 예약 오더접수
                                            </p>
                                            <p className="text-new font-bold text-[20px] pl-1.5 responsive1200:text-[18px]"> (익일발송)</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <Button
                        onClick={handleSubmit}
                        size="L"
                        disabled={isSubmittingOrder}
                        className="w-[630px] text-[20px] bg-new border-none text-white mb-16 responsive1200:w-[calc(100%-32px)] responsive1200:mx-auto"
                    >
                        오더접수
                    </Button>
                </div>
                {recentOrderShow && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center px-5">
                        <div className="bg-white w-full max-w-[800px] overflow-hidden rounded-2xl relative h-full flex flex-col max-h-[85dvh]">
                            <div className="flex items-center justify-between px-[4%] pt-6 pb-5">
                                <p className="text-2xl font-bold">최근 오더접수 내역</p>
                                <Close className="cursor-pointer" onClick={() => setRecentOrderShow(false)} />
                            </div>
                            <div className="mx-[4%] py-3 border text-[18px] rounded-lg flex items-center px-3">
                                <input
                                    value={searchTxt}
                                    onChange={e => setSearchTxt(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    className="bg-transparent px-1 w-full outline-0 focus:outline-none"
                                    placeholder="도착지 검색"
                                />
                                <Search className="cursor-pointer" onClick={handleSearch} />
                            </div>
                            <div className="flex flex-col py-5 px-[4%] overflow-hidden flex-1">
                                <div className="flex items-center justify-between flex-wrap gap-y-1">
                                    <p className="font-[500]">
                                        총 <span className="text-new">{lastOrder?.length}</span> 건
                                    </p>
                                    <div className="flex items-center gap-1">
                                        <Recent />
                                        <p className="text-[#878A93] text-sm">최근 1주일 이내 접수 내역이 조회됩니다.</p>
                                    </div>
                                </div>
                                <div className="flex-1 overflow-y-auto mt-2.5">
                                    <table className="w-full min-w-[600px]">
                                        <thead>
                                            <tr className="h-[50px] bg-[#F7F7F8] sticky top-0">
                                                <th className="w-[160px] font-normal">운송장번호</th>
                                                <th className="w-[120px] font-normal">발송 및 지불</th>
                                                <th className="w-[158px] bg-[#70737C14] font-[500]">출발지</th>
                                                <th>
                                                    <RightArrow />
                                                </th>
                                                <th className="w-[158px] bg-[#70737C14] font-[500]">도착지</th>
                                                <th className="w-[100px] font-normal">사용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lastOrder?.map((order, idx) => (
                                                <tr key={idx} className="border-b text-center h-[68px] text-[#1B1C1E] font-[500]">
                                                    <td className="text-[16px]">
                                                        <div>
                                                            <p>{order["운송장번호"]}</p>
                                                            <p className="text-[#666666] text-sm font-[400]">{order["날짜"]}</p>
                                                        </div>
                                                    </td>
                                                    <td className="text-[16px]">{order["발송및지불"]}</td>
                                                    <td className="text-[16px]">{order["출발지"]}</td>
                                                    <td>
                                                        <RightArrow />
                                                    </td>
                                                    <td className="text-[16px]">{order["도착지"]}</td>
                                                    <td className="flex items-center h-[68px] justify-center">
                                                        <Button
                                                            color="new"
                                                            onClick={() => {
                                                                didInitDepart.current = true;
                                                                setRecentOrderShow(false);
                                                                setPayMethod({
                                                                    pickup: order.s_kind === "H" ? 1 : 2,
                                                                    payment: Number(order.s_pay_kind),
                                                                    count: "",
                                                                    weight: String(order.s_weight),
                                                                    name: order.s_pay_company || "",
                                                                    tel: order.s_pay_tel || "",
                                                                    manager: order.s_pay_name || "",
                                                                    postcode: order.s_pay_post || "",
                                                                    address: order.s_pay_address || "",
                                                                    addressDetail: order.s_pay_address_detail || "",
                                                                    s_pay_company_code: order.s_pay_company_code || "",
                                                                });

                                                                setReceipt({
                                                                    name: order.a_company || "",
                                                                    tel: order.a_tel || "",
                                                                    department: order.a_part_sn || "",
                                                                    departmentName: order.a_part || "",
                                                                    manager: order.a_name || "",
                                                                    pickupMessage: order.a_request2 || "",
                                                                    deliveryMessage: order.a_request || "",
                                                                });

                                                                setDepart({
                                                                    displayName: order.f_company || "",
                                                                    name: order.f_company || "",
                                                                    tel: order.f_tel || "",
                                                                    manager: order.f_name || "",
                                                                    mobile: order.f_mobile || "",
                                                                    damCode: order.f_dam_code || "",
                                                                    postcode: order.f_post || "",
                                                                    address: order.f_address || "",
                                                                    addressDetail: order.f_address_detail || "",
                                                                    f_c_code: order.f_c_code || "",
                                                                    value: infoData
                                                                        ? infoData.c_addr_defalt === "1"
                                                                            ? infoData.C_Branch
                                                                            : infoData.c_addr_defalt === "2"
                                                                              ? infoData.C_RBranch
                                                                              : infoData.C_SeBranch
                                                                        : "01",
                                                                    roll: "",
                                                                    box: "",
                                                                    sample: "",
                                                                    linkPrint: "",
                                                                });

                                                                setArrive({
                                                                    name: order.t_company || "",
                                                                    tel: order.t_tel || "",
                                                                    manager: order.t_name || "",
                                                                    mobile: order.t_mobile || "",
                                                                    damCode: "",
                                                                    postcode: order.t_post || "",
                                                                    address: order.t_address || "",
                                                                    addressDetail: order.t_address_detail || "",
                                                                    t_c_code: order.t_c_code || "",
                                                                });

                                                                setRecentOrderShow(false);
                                                            }}
                                                        >
                                                            사용
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showCompletePop && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="absolute text-[#1b1c1e] z-[100] mt-[34px] flex flex-col gap-8 bg-white border w-full max-w-[560px] responsive700:max-w-[85%] responsive700:p-5 p-10 rounded-lg shadow-lg overflow-hidden">
                            <div className="text-2xl flex items-center justify-between">
                                <p className="font-[600]">
                                    {closedReason.holiday
                                        ? `오늘은 ${closedReason.holiday} 휴무일입니다`
                                        : closedReason.earlyName
                                          ? `${closedReason.endTime} 조기 종료 · ${closedReason.earlyName}`
                                          : `${closedReason.endTime} 이후 오더접수`}
                                </p>
                                <Close onClick={() => setShowCompletePop(false)} className="cursor-pointer" />
                            </div>
                            <p className="text-lg">
                                {isHolidayBlocked ? (
                                    holidayBlockedMessage
                                ) : (
                                    <>
                                        {closedReason.earlyName && (
                                            <>
                                                오늘은 조기 종료일({closedReason.earlyName})로 {closedReason.endTime}에 오더접수가
                                                마감되었습니다.
                                                <br />
                                            </>
                                        )}
                                        오더접수가 마감되어 송장출력만 가능하오니 출력 후 당일
                                        <br /> 발송(픽업) 가능 여부는 해당 픽업담당자분께 문의 바랍니다.
                                    </>
                                )}
                            </p>
                            <Button onClick={() => setShowCompletePop(false)} className="w-full border-none bg-new text-white" size="L">
                                확인
                            </Button>
                        </div>
                    </div>
                )}
                {submitConfirm && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="absolute text-[#1b1c1e] z-[100] mt-[34px] flex flex-col gap-8 bg-white border w-full max-w-[560px] responsive700:max-w-[85%] responsive700:p-5 p-10 rounded-lg shadow-lg overflow-hidden">
                            <div className="text-2xl flex items-center justify-between">
                                <p className="font-[600]">총 {selectedIdxList.length}건 오더접수</p>
                                <Close onClick={() => setSubmitConfirm(false)} className="cursor-pointer" />
                            </div>
                            <p className="text-lg">작성하신 내용으로 오더접수를 진행하시겠습니까?</p>
                            <div className="flex gap-2">
                                <Button onClick={() => setSubmitConfirm(false)} className="w-full" size="L">
                                    취소
                                </Button>
                                <Button
                                    onClick={() => handleSubmitConfirm()}
                                    disabled={isSubmittingOrder}
                                    className="disabled:opacity-70 w-full border-none bg-new text-white"
                                    size="L"
                                >
                                    접수
                                </Button>
                            </div>
                        </div>
                    </div>
                )}

                <div id="confirm-delete-pop-root"></div>
            </CustomerLayout>
        </React.Fragment>
    );
};

export default MorningOnlineOrder;
